// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1nDe9","label":"style_label__2oYMu","color":"style_color__3Sa90"};